export default "__VITE_ASSET__a804f238__"